import { isNonEmptyArray } from '#app/lib/boolean_tests'
import { convertEmToPx } from '#app/lib/utils'
import type { SerializedItemWithUserData } from '#inventory/lib/items'

const baseLineHeight = convertEmToPx(1)

// Pre-estimate the future height of the ItemCard, to not have to adjust based on real height after render
export function getEstimatedHeight (item: SerializedItemWithUserData) {
  // Empirically adjustment
  let guessedHeight = 50
  if (!item.snapshot['entity:title']) {
    // Unlikely case where item.snapshot is empty because the entity was not found
    return 150
  }
  if (item.snapshot['entity:image']) {
    guessedHeight += (300 + baseLineHeight)
  }
  if (isNonEmptyArray(item.snapshot['entity:seriesUris'])) {
    guessedHeight += item.snapshot['entity:seriesUris'].length * baseLineHeight
    guessedHeight += baseLineHeight
  }
  guessedHeight += Math.trunc(item.snapshot['entity:title'].length / 15) * 1.4 * baseLineHeight
  if (item.snapshot['entity:subtitle']) {
    guessedHeight += Math.trunc(item.snapshot['entity:subtitle'].length / 30) * 0.9 * baseLineHeight
    guessedHeight += baseLineHeight
  }
  if (item.snapshot['entity:authors']) {
    guessedHeight += Math.trunc(item.snapshot['entity:authors'].length / 30) * 0.9 * baseLineHeight
    guessedHeight += baseLineHeight
  }
  // mixed box
  guessedHeight += 3 * baseLineHeight
  // label box
  guessedHeight += 3 * baseLineHeight
  if (item.details) {
    const totalHeight = Math.trunc(item.details.length / 30) * baseLineHeight
    guessedHeight += Math.min(totalHeight, 8 * baseLineHeight)
  }
  if ('notes' in item && item.notes) {
    const totalHeight = Math.trunc(item.notes.length / 30) * baseLineHeight
    guessedHeight += Math.min(totalHeight, 8 * baseLineHeight)
  }
  if (item.transaction !== 'inventorying' && !item.mainUserIsOwner) {
    // request box
    guessedHeight += 3 * baseLineHeight
  }
  return guessedHeight
}
